var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5c-1.216 0-2.406.189-3.539.555A11.504 11.504 0 0 0 .5 12c0 6.351 5.149 11.5 11.5 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.957 11.805 9.08 15.827V7.784z"
  }))));
};
export default SvgPlay;